import { formattedPrice } from "../../utils";
import { checkBalanceAmount, checkUniqueReferenceNumber } from "./common";
import { ADB_ERROR_MESSAGE, ADJ_ERROR_MESSAGE, BFL_ERROR_MESSAGE, CARD_ERROR_MESSAGE, CASH_ERROR_MESSAGE, CHEQUE_ERROR_MESSAGES, CMP_ERROR_MESSAGE, DD_ERROR_MESSAGES, EDV_ERROR_MESSAGE, EFT_ERROR_MESSAGE, GQC_ERROR_MESSAGE, JEMI_ERROR_MESSAGE, JODO_ERROR_MESSAGE, LOAN_COMMON_ERROR_MESSAGE, ONLINE_PAYMENT_ERROR_MESSAGE, PRP_ERROR_MESSAGE, QRC_ERROR_MESSAGE, SDJ_ERROR_MESSAGE, VOUCHER_ERROR_MESSAGE } from "./validationMessage"

export const cashValidtion=(paymentModeForm, balanceAmount,maxCashLimit,collectPayment=[])=>{
       const cashObj=collectPayment.find((item)=>item?.paymentMode=='CASH')
       const cashAmount =cashObj?.paidAmount ?? 0 
       if(checkBalanceAmount(paymentModeForm,balanceAmount)) {
              return CASH_ERROR_MESSAGE?.MORE_THEN_BALANCE
       }
       else if((Number(paymentModeForm?.paidAmount) + Number(cashAmount)) > maxCashLimit && maxCashLimit){
              return  `In line with amendment in Income Tax act, we cannot take more than ${maxCashLimit} in cash for any courses from a single student. Kindly choose some other payment mode and proceed.`
       }
}

export const chequeDDValidation = (paymentModeForm, collectPayment, currentPaymentMode, balanceAmount) => {

       if (currentPaymentMode == 'cheque') {
              let error = checkUniqueReferenceNumber(collectPayment, paymentModeForm?.referenceNumber, 'CHKL', paymentModeForm?.indexToEdit);
              if (error) {
                     return CHEQUE_ERROR_MESSAGES?.DUPLICATE_CHEQUE
              }

              else if (paymentModeForm?.paidAmount == 0) {
                     return CHEQUE_ERROR_MESSAGES?.PAID_AMOUNT
              }
              else if (paymentModeForm?.referenceNumber.length < 6 || paymentModeForm?.referenceNumber === '') {
                     return CHEQUE_ERROR_MESSAGES?.CHEQUE_NUMBER
              }
              else if(checkBalanceAmount(paymentModeForm,balanceAmount)) {
                     return CHEQUE_ERROR_MESSAGES?.MORE_THEN_BALANCE
              }
       }
       else if (currentPaymentMode == 'dd') {
              let error = checkUniqueReferenceNumber(collectPayment, paymentModeForm?.referenceNumber, 'DD',paymentModeForm?.indexToEdit);
              if (error) {
                     return DD_ERROR_MESSAGES?.DUPLICATE_DD
              }

              else if (paymentModeForm?.paidAmount == 0) {
                     return DD_ERROR_MESSAGES?.PAID_AMOUNT
              }
              else if (paymentModeForm?.referenceNumber.length < 6 || paymentModeForm?.referenceNumber === '') {
                     return DD_ERROR_MESSAGES?.DD_NUMBER
              }
              else if(checkBalanceAmount(paymentModeForm,balanceAmount)) {
                     return DD_ERROR_MESSAGES?.MORE_THEN_BALANCE
              }
       }

}

export const  cardValidation=(paymentModeForm, balanceAmount)=>{
       if(checkBalanceAmount(paymentModeForm,balanceAmount)) {
              return CARD_ERROR_MESSAGE?.MORE_THEN_BALANCE
       }
        if (paymentModeForm?.referenceNumber.length <4) {
              return CARD_ERROR_MESSAGE?.CARD_NUMBER
       }
}

export const posValidation=(amountEntered,balanceAmount)=>{
       if(amountEntered>balanceAmount)
              return CARD_ERROR_MESSAGE?.MORE_THEN_BALANCE
}

export const adbLoanValidation =async (paymentModeForm, collectPayment, balanceAmount) => {
       let error = checkUniqueReferenceNumber(collectPayment, paymentModeForm?.referenceNumber?.label, 'ADB',paymentModeForm?.indexToEdit);
       if (error) {
              return ADB_ERROR_MESSAGE?.DUPLICATE_AESL_SLIP
       }
       else if (checkBalanceAmount(paymentModeForm,balanceAmount)) {
              return ADB_ERROR_MESSAGE?.MORE_THEN_BALANCE
       }
}
export const onlineValidation =async (paymentModeForm, collectPayment, balanceAmount) => {
       let error = checkUniqueReferenceNumber(collectPayment, paymentModeForm?.referenceNumber, 'OP',paymentModeForm?.indexToEdit);
       if (error) {
              return ONLINE_PAYMENT_ERROR_MESSAGE?.DUPLICATE_TRANSACTIONID
       }
       else if (checkBalanceAmount(paymentModeForm,balanceAmount)) {
              return `${ONLINE_PAYMENT_ERROR_MESSAGE?.MORE_THEN_BALANCE} ${formattedPrice(balanceAmount)}`
       }
}

export const eftValidation =async (paymentModeForm, collectPayment, balanceAmount) => {
       let error = checkUniqueReferenceNumber(collectPayment, paymentModeForm?.referenceNumber, 'EFT',paymentModeForm?.indexToEdit);
       if (error) {
              return EFT_ERROR_MESSAGE?.DUPLICATE_TRANSACTIONID
       }
       else if (checkBalanceAmount(paymentModeForm,balanceAmount)) {
              return `${EFT_ERROR_MESSAGE?.MORE_THEN_BALANCE}${formattedPrice(balanceAmount)}`
       }
}

export const jodoValidation =async (paymentModeForm, collectPayment, balanceAmount) => {
       let error = checkUniqueReferenceNumber(collectPayment, paymentModeForm?.referenceNumber, 'JODO',paymentModeForm?.indexToEdit);
       if (error) {
              return JODO_ERROR_MESSAGE?.DUPLICATE_FLEXID
       }
       else if (checkBalanceAmount(paymentModeForm,balanceAmount)) {
              return `${JODO_ERROR_MESSAGE?.MORE_THEN_BALANCE} ${balanceAmount}`
       }
}
export const qrcValidation =async (paymentModeForm, collectPayment, balanceAmount) => {
       let error = checkUniqueReferenceNumber(collectPayment, paymentModeForm?.referenceNumber, 'QRC',paymentModeForm?.indexToEdit);
       if (error) {
              return QRC_ERROR_MESSAGE?.DUPLICATE_ORDERID
       }
       else if (checkBalanceAmount(paymentModeForm,balanceAmount)) {
              return `${QRC_ERROR_MESSAGE?.MORE_THEN_BALANCE} ${balanceAmount}`
       }
}

export const loanValidation = (paymentModeForm, collectPayment,currentPaymentMode, balanceAmount) => {
       if (currentPaymentMode === 'loanEDV') {
              let error = checkUniqueReferenceNumber(collectPayment, paymentModeForm?.referenceNumber?.label, 'EDV',paymentModeForm?.indexToEdit);
              if (error) {
                     return LOAN_COMMON_ERROR_MESSAGE?.DUPLICATE_DOID
              }

             else  if (checkBalanceAmount(paymentModeForm,balanceAmount)) {
              
                     return EDV_ERROR_MESSAGE?.MORE_THEN_BALANCE
              }
       }
       else if (currentPaymentMode === 'loanBFL') {
              let error = checkUniqueReferenceNumber(collectPayment, paymentModeForm?.referenceNumber?.label, 'BFL', paymentModeForm?.indexToEdit);
              if (error) {
                     return LOAN_COMMON_ERROR_MESSAGE?.DUPLICATE_DOID
              }
              else if (checkBalanceAmount(paymentModeForm,balanceAmount)) {
                     return BFL_ERROR_MESSAGE?.MORE_THEN_BALANCE
              }
       }

       else if (currentPaymentMode === 'loanPRP') {
              let error = checkUniqueReferenceNumber(collectPayment, paymentModeForm?.referenceNumber?.label, 'PRP', paymentModeForm?.indexToEdit);
              if (error) {
                     return LOAN_COMMON_ERROR_MESSAGE?.DUPLICATE_DOID
              }
              
              else if (checkBalanceAmount(paymentModeForm,balanceAmount)) {
                     
                     return PRP_ERROR_MESSAGE?.MORE_THEN_BALANCE
              }
              
       }
       else if (currentPaymentMode === 'gqc') {
              let error = checkUniqueReferenceNumber(collectPayment, paymentModeForm?.referenceNumber?.label, 'GQC', paymentModeForm?.indexToEdit);
              if (error) {
                     return LOAN_COMMON_ERROR_MESSAGE?.DUPLICATE_DOID
              }
              
              else if (checkBalanceAmount(paymentModeForm,balanceAmount)) {
                     
                     return GQC_ERROR_MESSAGE?.MORE_THEN_BALANCE
              }
              
       }
       else if (currentPaymentMode === 'jemi') {
              let error = checkUniqueReferenceNumber(collectPayment, paymentModeForm?.referenceNumber?.label, 'JEMI', paymentModeForm?.indexToEdit);
              if (error) {
                     return LOAN_COMMON_ERROR_MESSAGE?.DUPLICATE_DOID
              }
              
              else if (checkBalanceAmount(paymentModeForm,balanceAmount)) {
                     
                     return JEMI_ERROR_MESSAGE?.MORE_THEN_BALANCE
              }
              
       }
}

export const adjustmentValidation = (paymentModeForm, collectPayment, currentPaymentMode, balanceAmount, adjustmentAmount) => {
       if (currentPaymentMode === 'sdj' && (checkBalanceAmount(paymentModeForm,balanceAmount)||checkBalanceAmount(paymentModeForm,adjustmentAmount))) {
              return SDJ_ERROR_MESSAGE?.MORE_THEN_BALANCE
       }
       if (currentPaymentMode === 'cmp' && (checkBalanceAmount(paymentModeForm,balanceAmount)||checkBalanceAmount(paymentModeForm,adjustmentAmount))) {
              return CMP_ERROR_MESSAGE.MORE_THEN_BALANCE
       }
       if (currentPaymentMode === 'adj' && (checkBalanceAmount(paymentModeForm,balanceAmount)||checkBalanceAmount(paymentModeForm,adjustmentAmount))) {
              return ADJ_ERROR_MESSAGE?.MORE_THEN_BALANCE
       }
}

export const voucherValidtion=(totalVoucherAmount, balanceAmount)=>{
       if(totalVoucherAmount > balanceAmount) {
              return VOUCHER_ERROR_MESSAGE?.MORE_THEN_BALANCE
       }

}

export const pdcValidation = (studentBasicDetails,selectedCharges)=>{
       const firtTwoDIgit=Math.floor(studentBasicDetails?.term / 100)
       return (firtTwoDIgit>=25&& !(studentBasicDetails?.detailsMap?.hasPDCCharge || studentBasicDetails?.detailsMap?.isPDCPaid || (selectedCharges?.["OTHER_CHARGES"])?.length>0))
}







